import { useState } from 'react';

import { Nullable } from 'chaika-common-types';
import { OptionType } from '@components/Select';
import { store } from '@store';

export function useOrganizationHandlers() {
    const [selectedOrganizations, setSelectedOrganizations] = useState<Nullable<OptionType<string>[]>>();
    const [organizationsWithoutStore, setOrganizationsWithoutStore] = useState<string[]>();

    const { organizationList } = store;

    function onSelectOrganizations(params: Nullable<OptionType<string>[]>): void {
        const organizations = params?.map(param => organizationList.getExisting(param.value)) || [];
        const organizationsWithoutStoreNames = organizations.filter(item => !item.storeId).map(item => item.name);

        setOrganizationsWithoutStore(organizationsWithoutStoreNames);
        setSelectedOrganizations(() => params);
    }

    return {
        selectedOrganizations,
        organizationsWithoutStore,
        onSelectOrganizations,
    };
}
